import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';

function InvitationsCreated() {
  return (
    <>
      <div className="font-semibold text-2xl">
        <T kind="Invitations Created" />
      </div>

      <p className="font-semibold mt-8">
        <T kind="What would you like to do next?" />
      </p>
    </>
  );
}

export default observer(InvitationsCreated);
